import { Address } from '@/types/common';

export function buildAddress({
  line1,
  line2,
  city,
  state,
  country,
  postalCode,
}: Address) {
  if (!line1) {
    return '';
  }

  const line3 = `${city}, ${state} ${postalCode}`;
  const baseAddress = line2
    ? `${line1}\n${line2}\n${line3}`
    : `${line1}\n${line3}`;
  return country ? `${baseAddress}\n${country}` : baseAddress;
}
